import { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import AdminShell from "../../components/AdminShell";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    adminApi.get("/admin/users").then((r) => setUsers(r.data));
  }, []);

  const filtered = users.filter((u) => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (u.email || "").toLowerCase().includes(q) || (u.name || "").toLowerCase().includes(q);
  });

  const totalSpent = users.reduce((s, u) => s + (u.spent || 0), 0);
  const buyers = users.filter((u) => (u.orders || 0) > 0).length;

  return (
    <AdminShell>
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="brand-tag">// Users</div>
          <h1 className="font-display text-5xl uppercase tracking-tight mt-1">Buyers</h1>
        </div>
        <div className="flex gap-1">
          <Stat label="Total Users" value={users.length} />
          <Stat label="Active Buyers" value={buyers} accent />
          <Stat label="Lifetime ₹" value={totalSpent.toLocaleString("en-IN")} />
        </div>
      </div>

      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by name or email"
        className="mt-6 bg-transparent border border-[#E5E1D8] px-3 h-10 font-mono-ds text-sm focus:border-[#FF6A00] outline-none min-w-[300px]"
        data-testid="user-search-input"
      />

      <div className="mt-4 border border-[#E5E1D8] bg-[#FFFFFF] overflow-x-auto">
        <table className="w-full text-sm font-mono-ds min-w-[800px]">
          <thead className="border-b border-[#E5E1D8] text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E]">
            <tr>
              <th className="text-left p-4">User</th>
              <th className="text-left p-4">Phone</th>
              <th className="text-left p-4">Orders</th>
              <th className="text-left p-4">Spent</th>
              <th className="text-left p-4">Last Order</th>
              <th className="text-left p-4">Joined</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-[#6E6E6E]">// No users match</td></tr>
            )}
            {filtered.map((u) => (
              <tr key={u.user_id} className="border-b border-[#FFFFFF] hover:bg-[#FFFFFF]/70" data-testid={`user-row-${u.user_id}`}>
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 border border-[#E5E1D8] overflow-hidden bg-[#FFFFFF] flex items-center justify-center">
                      {u.picture ? (
                        <img src={u.picture} alt="" className="w-full h-full object-cover" />
                      ) : (
                        <span className="font-display text-sm text-[#FF6A00]">
                          {(u.name || u.email || "?").slice(0, 1).toUpperCase()}
                        </span>
                      )}
                    </div>
                    <div>
                      <div className="text-[#161616]">{u.name || "—"}</div>
                      <div className="text-[10px] text-[#6E6E6E]">{u.email}</div>
                    </div>
                  </div>
                </td>
                <td className="p-4 text-[#6E6E6E]">{u.phone || "—"}</td>
                <td className="p-4">
                  <span className={`${(u.orders || 0) > 0 ? "text-[#FF6A00] font-bold" : "text-[#6E6E6E]"}`}>
                    {u.orders || 0}
                  </span>
                </td>
                <td className="p-4 text-[#161616]">{(u.spent || 0) > 0 ? `₹${u.spent.toLocaleString("en-IN")}` : "—"}</td>
                <td className="p-4 text-[#6E6E6E] text-[10px]">{u.last_order ? new Date(u.last_order).toLocaleString("en-IN") : "—"}</td>
                <td className="p-4 text-[#6E6E6E] text-[10px]">{u.created_at ? new Date(u.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
}

function Stat({ label, value, accent }) {
  return (
    <div className={`border ${accent ? "border-[#FF6A00]" : "border-[#E5E1D8]"} bg-[#FFFFFF] px-4 py-2`}>
      <div className="font-mono-ds text-[9px] uppercase tracking-[0.3em] text-[#6E6E6E]">{label}</div>
      <div className={`font-display text-2xl ${accent ? "text-[#FF6A00]" : "text-[#161616]"}`}>{value}</div>
    </div>
  );
}
